module.exports = __webpack_public_path__ + "static/img/p5.f4bc739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/p5.jpg
// module id = ZRnY
// module chunks = 0